import React from 'react';
import Icon from './Icon';

const PILLARS = [
  {
    href: '#voice-ai',
    icon: 'phone',
    title: 'Voice AI ordering',
    body: 'A phone host that takes complete orders with sizes, spice levels and special requests, around the clock.',
    big: true,
  },
  {
    href: '#upselling',
    icon: 'sparkles',
    title: 'AI upselling',
    body: 'Suggests the add-on you chose for each dish, once, right before the total.',
  },
  {
    href: '#languages',
    icon: 'globe',
    title: 'Multilingual',
    body: 'English, Spanish, Chinese, Punjabi and many more, with dish names pronounced properly.',
  },
  {
    href: '#kiosk',
    icon: 'kiosk',
    title: 'Self-order kiosk',
    body: 'Guests browse, customize and order at the counter without waiting in line.',
  },
  {
    href: '#admin',
    icon: 'dashboard',
    title: 'Admin portal',
    body: 'Orders from every channel in one place. Menu, hours and sold-out items, all one tap away.',
  },
];

export default function Platform() {
  return (
    <section className="section light section--tight-top" id="platform">
      <div className="wrap">
        <div className="section__head" data-reveal>
          <p className="eyebrow">One platform</p>
          <h2 className="h2">
            Phone, kiosk and kitchen, <em>finally talking to each other.</em>
          </h2>
          <p className="lead lead--dark">
            Every order goes to the same place, whether it came in by phone, kiosk or your website.
            It prints in the kitchen and shows up on the counter tablet.
          </p>
        </div>
        <div className="bento">
          {PILLARS.map((p) => (
            <a key={p.title} href={p.href} className={`bento__card${p.big ? ' bento__card--big' : ''}`} data-reveal>
              <span className="icon-chip">
                <Icon name={p.icon} />
              </span>
              <h3>{p.title}</h3>
              <p>{p.body}</p>
              <span className="bento__more">
                Learn more <Icon name="arrow" size={16} />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
